import React, { useContext } from 'react';
import { FMAccordion } from '@own/fds-react';
import { CheckboxItems } from '@own/fds-react/dist/types/checkbox.types';
import { BookmarkContext } from '../../../../../views/dyf-landing-view/context/dyf-bookmark-context';
import { DyfFeatureGuideContentProps } from '../../../../../views/dyf-landing-view/hooks/use-dyf-feature-guide-content';
import { SignInReplaceComponent } from '../../../dyf-landing/sign-in-replace-component/sign-in-replace-component';
import { DisabledCheckboxes } from '../disabled-checkboxes/disabled-checkboxes';
import { useOnboardingFeatureToggles } from '../../../../../hooks/dyf/use-onboarding-feature-toggles/use-onboarding-feature-toggles';
import { FmCheckbox } from '../../../../common/fm-checkbox/fm-checkbox';

interface YourVehicleFeaturesCheckboxesProps {
    allFeaturesCheckbox: CheckboxItems;
    allCategories: CheckboxItems[];
    disabledCategories: CheckboxItems[] | null;
    myBookmarksCheckbox: CheckboxItems;
    featureGuideContent: DyfFeatureGuideContentProps;
    isAuth: boolean;
    onLogin: () => void;
}

const YourVehicleFeaturesAllCheckboxes = (
    props: YourVehicleFeaturesCheckboxesProps
) => {
    const { shouldShowBookmarkFeature } = useContext(BookmarkContext);
    const { enableUnauthFeatureCategory } = useOnboardingFeatureToggles();
    return (
        <>
            <div className="all-features-checkbox checkbox-section">
                <FmCheckbox
                    checkboxArray={[props.allFeaturesCheckbox]}
                    direction="standard"
                />
            </div>
            <div className="all-categories-checkboxes">
                <div className="visible-categories-checkboxes checkbox-section">
                    <FmCheckbox
                        checkboxArray={props.allCategories}
                        direction="standard"
                    />
                </div>
                <div className="your-vehicle-features-borderline"></div>
                {!props.isAuth && (
                    <div
                        className="your-vehicle-features-sign-in"
                        data-testid="your-vehicle-features-sign-in"
                    >
                        <SignInReplaceComponent
                            bolded
                            handleLogin={props.onLogin}
                            description={
                                props.featureGuideContent
                                    .vehicleFeaturesSignInDescription
                            }
                        />
                    </div>
                )}

                {enableUnauthFeatureCategory && (
                    <DisabledCheckboxes
                        disabledCategories={props.disabledCategories}
                    />
                )}
            </div>
            {shouldShowBookmarkFeature && (
                <div className="my-bookmarks-checkbox checkbox-section">
                    <FmCheckbox
                        checkboxArray={[props.myBookmarksCheckbox]}
                        direction="standard"
                    />
                </div>
            )}
        </>
    );
};

const YourVehicleFeaturesCheckboxes: React.FC<YourVehicleFeaturesCheckboxesProps> = props => {
    return (
        <>
            <div
                className="your-vehicle-features-desktop"
                data-testid="vehicle-features-desktop"
            >
                <YourVehicleFeaturesAllCheckboxes {...props} />
            </div>
            <div
                className="your-vehicle-features-mobile"
                data-testid="vehicle-features-mobile"
            >
                <FMAccordion
                    theme="light"
                    panels={[
                        {
                            index: 1,
                            title:
                                props.featureGuideContent.mobileAccordionLabel,
                            panel: (
                                <YourVehicleFeaturesAllCheckboxes {...props} />
                            ),
                        },
                    ]}
                />
            </div>
        </>
    );
};

export default YourVehicleFeaturesCheckboxes;
